import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "../styles/polaris-admin.css";

export default function PolarisSalesPage() {
    const location = useLocation();
    const onProvision = location.pathname.includes("/sales/provision");

    return (
        <section className="pa-section pa-sales-page" data-testid="polaris-sales-page">
            <h1 className="pa-page-title">Sales</h1>
            <p className="pa-section-subtitle">
                Track inbound contact requests and provision custom organization subscriptions after demos.
            </p>

            <div className="pa-tabs" role="tablist" aria-label="Sales sections">
                <NavLink
                    to="/polaris-admin/sales"
                    end
                    role="tab"
                    aria-selected={!onProvision}
                    className={({ isActive }) => `pa-tab${isActive ? " active" : ""}`}
                    data-testid="polaris-sales-tab-leads"
                >
                    Leads
                </NavLink>
                <NavLink
                    to="/polaris-admin/sales/provision"
                    role="tab"
                    aria-selected={onProvision}
                    className={({ isActive }) => `pa-tab${isActive ? " active" : ""}`}
                    data-testid="polaris-sales-tab-provision"
                >
                    Provision organization
                </NavLink>
            </div>

            <Outlet />
        </section>
    );
}
